import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';


@Component({
  selector: 'app-me-dieta',
  templateUrl: './me-dieta.component.html',
  styleUrls: ['./me-dieta.component.css']
})
export class MeDietaComponent implements OnInit {

  existeTreino: boolean = false;
  hideCL: boolean = false;
  idDieta: any = 0;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router) { }

  //fator na url
  //se fator  = 0, significa que é semana atual,
  //else - cada numero significada 1 semana atrás
  //ver na agenda esquema de avançar / voltar dias, mas adaptar para semanas
  ngOnInit() {
    this.hideCL = true;
    this.existeTreino = true;
    const id = +this.route.snapshot.paramMap.get('iddieta');
    this.idDieta = id;
  }

  goCardapio(ds: any, diadm : any) :void{
    
    this.router.navigate(['me/cardapio/' + this.idDieta + "/" + ds + "/" + diadm]);
  }
  voltar() :void{
    this.router.navigate(['me/dietas']);
  }

}
